import React from "react";
import { Spinner } from "react-bootstrap";

const CheckingStep = ({
  step,
  idx,
  onClickStep,
  requesting,
  targetStep
}) => {
  const { label, value, checked } = step

  return (
    <div className={`${idx === 0 ? "" : "border-top"} row py-3 align-items-center`} key={value}>
      <div className="col-sm-1">
        <span className="bi bi-check-circle-fill" style={{ color: `${checked ? "green" : "grey"}` }}></span>
      </div>
      <div className="col-sm-4">
        {label}
      </div>
      <div className="col-sm-7 text-right">
        <button
          className="btn btn-outlined-blue m-1"
          type="button"
          disabled={requesting || targetStep?.value === value}
          onClick={() => onClickStep(step)}>
          {requesting && targetStep?.value === value && <Spinner className="ml-1" animation="border" role="status" size="sm" />}
          {checked ? "Uncomplete" : "Complete"}
        </button>
      </div>
    </div>
  )
}

export default CheckingStep